// extracted by mini-css-extract-plugin
var _1 = "Dropdown-moduledropdown__fsRjQ";
export { _1 as "dropdown" }
